// extracted by mini-css-extract-plugin
export default {"root":"Metabolism_root__qyT+c","bubbleRoot":"Metabolism_bubbleRoot__WO0GN","bubble":"Metabolism_bubble__qH8gN","bodyImage":"Metabolism_bodyImage__wDrb5"};